import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.666 22.17a5.833 5.833 0 0 1 5.833-5.834h7a5.833 5.833 0 0 1 5.834 5.833 3.5 3.5 0 0 1-3.5 3.5H8.166a3.5 3.5 0 0 1-3.5-3.5m3.5-13.999a5.833 5.833 0 1 1 11.667 0 5.833 5.833 0 0 1-11.667 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }